// Utilidades para cargar datos paginados con virtual loading

export const createPaginatedLoader = () => {
  return {
    items: [],
    loadingItems: [], // Items fake/skeleton para feedback visual
    currentPage: 1,
    totalPages: 1,
    hasMore: true,
    isLoading: false,
    pageSize: 20,

    // Crear items fake para mostrar mientras se cargan
    createSkeletonItems(count = 20) {
      return Array.from({ length: count }, (_, i) => ({
        id: `skeleton-${Date.now()}-${i}`,
        val: `skeleton-${Date.now()}-${i}`,
        name: '...',
        ID: '...',
        prod: {
          ItemNewPrice: 0,
          Availability: 0,
          type: 'product'
        },
        _isSkeleton: true
      }));
    },

    // Reiniciar cargador
    reset() {
      this.items = [];
      this.loadingItems = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.hasMore = true;
      this.isLoading = false;
    },

    // Obtener items para mostrar (reales + skeletons)
    getDisplayItems() {
      return [...this.items, ...this.loadingItems];
    },

    // Actualizar después de cargar datos
    updateWithResponse(response, shouldAppend = false) {
      this.isLoading = false;
      this.loadingItems = [];

      if (response.data && Array.isArray(response.data)) {
        if (shouldAppend) {
          this.items = [...this.items, ...response.data];
        } else {
          this.items = response.data;
        }
      }

      if (response.pagination) {
        this.currentPage = response.pagination.page;
        this.totalPages = response.pagination.pages;
        this.hasMore = response.pagination.hasMore;
      }
    },

    // Preparar para cargar
    prepareForLoading() {
      this.isLoading = true;
      this.loadingItems = this.createSkeletonItems(this.pageSize);
    },

    // Siguiente página
    nextPage() {
      if (this.hasMore && !this.isLoading) {
        return this.currentPage + 1;
      }
      return null;
    }
  };
};
